import { Component } from "@angular/core";

@Component({
  selector: 'qr-page-not-found',
  templateUrl: './qr-not-found.component.html',
  styleUrls: ['./qr-not-found.component.scss'],
})
export class QRPageNotFoundComponent { }
